import type { ExcursionsComponentProps } from "@op/puck-types";
import { Excursion } from "../../../../../components/base/Excursion/Excursion";

const Excursions = ({ excursions }: ExcursionsComponentProps) => {
  return (
    <div id="excursions">
      {excursions.map((excursion, index) => (
        <Excursion
          key={`${excursion.slug}-${index}`}
          data={excursion.data}
          slug={excursion.slug}
          index={index}
        />
      ))}
    </div>
  );
};

export default Excursions;
